import en from "./en";
import sv from "./sv";
import da from "./da";
import nl from "./nl";
import fi from "./fi";
import de from "./de";
import th from "./th";
import ar from "./ar";

var texts = {
  en: en,
  sv: sv,
  da: da,
  nl: nl,
  fi: fi,
  de: de,
  th: th,
  ar: ar,
};

var language = textsoverride => {
  var ret = {
    text: text(),
    texts: texts,
  };

  if (textsoverride) {
    for (var lang in texts) {
      if (textsoverride.hasOwnProperty(lang)) {
        if (!texts[lang]) {
          texts[lang] = {};
        }
        texts[lang] = {
          ...texts[lang],
          ...textsoverride[lang],
        };
      } else {
        delete ret.texts[lang];
      }
    }
  }

  return ret;
};

function text() {
  return str => {
    var lang = navigator.language;

    //Default lang is en
    if (!lang) lang = "en";

    //Try to get browser lang
    var tmp = texts[lang];

    //Try to get browser lang first 2 chars
    if (!tmp && lang.length > 2) {
      tmp = texts[lang.substring(0, 2)];
    }

    //Defaults to first element in languages array
    if (!tmp) {
      tmp = texts[Object.keys(texts)[0]];
    }

    //Error msg
    if (!tmp) {
      console.error(
        "translation missing for " +
          lang +
          " " +
          lang.substring(0, 2) +
          " and en"
      );
      return str;
    }

    var ret = tmp[str];
    if (!ret) ret = "?" + str;

    return ret;
  };
}

export default language;






// WEBPACK FOOTER //
// ./src/branding/default/language/language.js